<template>
  <div class="courses">
    <main>
      <section class="py-0 text-center container">
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
            <h1 class="fw-light">Kurslar</h1>
          </div>
        </div>
      </section>

      <div class="album py-5 bg-light">
        <div class="container">

          <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            <div class="col" v-for="card in cards">
              <div class="card shadow-sm">
                <img class="bd-placeholder-img card-img-top" width="100%" height="225" :src="card.get_image"/>

                <div class="card-body">
                  <p class="card-text">{{card.title}}</p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <a :href="'/news/' + card.slug" class="btn btn-sm btn-outline-secondary"
                        >Batafsil</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

    </main>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data(){
    return{
      cards:[]
    }
  },
  mounted() {
    axios.get(`courses/get_all_blogs/`).then((response) => {
      this.cards = response.data;
    });
  },
 
};
</script>